export class SelectionAnnotation {
    constructor() {
        this.selectionId = "";
        this.text = "";
    }
    clone() {
        const result = new SelectionAnnotation();
        result.selectionId = this.selectionId;
        result.text = this.text;
        return result;
    }
    static load(source) {
        var result = new SelectionAnnotation();
        if (!source) {
            return result;
        }
        result.selectionId = source.selectionId;
        result.text = source.text;
        return result;
    }
}
export const hasSomeAnswer = (answer) => {
    return (answer.booleanAnswer ||
        answer.numberAnswer ||
        answer.numberAnswerHigh ||
        answer.textAnswer ||
        answer.dateAnswer ||
        answer.selections?.length > 0 ||
        answer.selectionAnnotations?.length > 0);
};
export class Answer {
    constructor() {
        this.questionId = null;
        this.booleanAnswer = null;
        this.numberAnswer = null;
        this.numberAnswerHigh = null;
        this.dateAnswer = null;
        this.calendarDateAnswer = null;
        this.textAnswer = null;
        this.selections = [];
        this.selectionAnnotations = [];
        this.idReferenceAnswer = null;
        this._id = null;
        this.key = "";
    }
    clone() {
        return Answer.clone(this);
    }
    static empty() {
        var result = new Answer();
        result.booleanAnswer = false;
        result.numberAnswer = 0;
        result.numberAnswerHigh = 0;
        result.selections = [];
        result.textAnswer = "";
        result.dateAnswer = null;
        result.calendarDateAnswer = null;
        result.key = "";
        result.idReferenceAnswer = null;
        return result;
    }
    static clone(source) {
        var theClone = new Answer();
        if (!source) {
            return theClone;
        }
        theClone.questionId = source.questionId;
        theClone.booleanAnswer = source.booleanAnswer;
        theClone.numberAnswer = source.numberAnswer;
        theClone.numberAnswerHigh = source.numberAnswerHigh;
        theClone.textAnswer = source.textAnswer ? `${source.textAnswer}` : null;
        theClone.selections = (source.selections || []).slice();
        theClone.selectionAnnotations = (source.selectionAnnotations || []).map(sa => sa.clone());
        theClone.dateAnswer = source.dateAnswer;
        theClone.calendarDateAnswer = source.calendarDateAnswer;
        theClone.idReferenceAnswer = source.idReferenceAnswer;
        theClone._id = source._id;
        theClone.key = source.key;
        return theClone;
    }
    static load(source) {
        var loaded = new Answer();
        if (!source) {
            return loaded;
        }
        loaded.questionId = source.questionId && source.questionId.toString();
        loaded.booleanAnswer = source.booleanAnswer;
        loaded.numberAnswer = source.numberAnswer;
        loaded.numberAnswerHigh = source.numberAnswerHigh;
        loaded.dateAnswer = source.dateAnswer;
        loaded.calendarDateAnswer = source.calendarDateAnswer;
        loaded.textAnswer = source.textAnswer ? `${source.textAnswer}` : null;
        loaded.idReferenceAnswer = source.idReferenceAnswer && source.idReferenceAnswer;
        loaded.selections = (source.selections || []).map((s) => s && s.toString());
        loaded.selectionAnnotations = (source.selectionAnnotations || []).map((sa) => sa && SelectionAnnotation.load(sa));
        loaded._id = source._id;
        return loaded;
    }
    toUpdateOperation(prefix) {
        var x = {};
        if (typeof this.dateAnswer !== "undefined")
            x[`${prefix}dateAnswer`] = this.dateAnswer;
        if (typeof this.calendarDateAnswer !== "undefined")
            x[`${prefix}calendarDateAnswer`] = this.calendarDateAnswer;
        if (typeof this.booleanAnswer !== "undefined")
            x[`${prefix}booleanAnswer`] = this.booleanAnswer;
        if (typeof this.idReferenceAnswer !== "undefined")
            x[`${prefix}idReferenceAnswer`] = this.idReferenceAnswer;
        if (typeof this.numberAnswer !== "undefined")
            x[`${prefix}numberAnswer`] = this.numberAnswer;
        if (typeof this.numberAnswerHigh !== "undefined")
            x[`${prefix}numberAnswerHigh`] = this.numberAnswerHigh;
        if (typeof this.textAnswer !== "undefined")
            x[`${prefix}textAnswer`] = this.textAnswer;
        if (typeof this.selections !== "undefined")
            x[`${prefix}selections`] = this.selections;
        if (typeof this.selectionAnnotations !== "undefined")
            x[`${prefix}selectionAnnotations`] = this.selectionAnnotations;
        return x;
    }
}
//# sourceMappingURL=answer.js.map